/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section3_Li5Inputs */

const en_about_section3_li5 = /** @type {(inputs: About_Section3_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Diff & Sorter: Compare two JSON documents or sort object keys alphabetically`)
};

const ko_about_section3_li5 = /** @type {(inputs: About_Section3_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 비교 & 정렬: 두 JSON 문서 비교 또는 객체 키를 알파벳순으로 정렬`)
};

const ja_about_section3_li5 = /** @type {(inputs: About_Section3_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON比較＆ソート: 2つのJSONドキュメントの比較またはオブジェクトキーをアルファベット順にソート`)
};

/**
* | output |
* | --- |
* | "JSON Diff & Sorter: Compare two JSON documents or sort object keys alphabetically" |
*
* @param {About_Section3_Li5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section3_li5 = /** @type {((inputs?: About_Section3_Li5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section3_Li5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section3_li5(inputs)
	if (locale === "ko") return ko_about_section3_li5(inputs)
	return ja_about_section3_li5(inputs)
});